(() => {
  function initStickyATC(root) {
    const sectionId = root?.dataset?.sectionId;
    if (!sectionId) return;

    const variantSelect = root.querySelector("[data-sticky-variant]");
    const atcBtn = root.querySelector("[data-sticky-atc-btn]");
    const buyBtn = root.querySelector("[data-sticky-buy-btn]");

    const form = document.getElementById(`product-form-${sectionId}`);
    if (!form) return;

    const idInput = form.querySelector('input[name="id"]');

    // Set sticky dropdown to current selected variant
    if (idInput && variantSelect) {
      variantSelect.value = idInput.value;
    }

    // When sticky dropdown changes, update main form variant ID input
    variantSelect?.addEventListener("change", () => {
      if (!idInput) return;
      idInput.value = variantSelect.value;
      idInput.dispatchEvent(new Event("change", { bubbles: true }));
    });

    // Click the real Add to cart button
    atcBtn?.addEventListener("click", () => {
      const realATC = form.querySelector('button[name="add"]');
      if (realATC) realATC.click();
    });

    // Click the real Buy it now button
    buyBtn?.addEventListener("click", () => {
      const realBuy = form.querySelector(".shopify-payment-button__button");
      if (realBuy) {
        realBuy.click();
      } else {
        // fallback: add to cart if payment button not present
        const realATC = form.querySelector('button[name="add"]');
        if (realATC) realATC.click();
      }
    });
  }

  function boot() {
    document.querySelectorAll("[data-sticky-atc]").forEach(initStickyATC);
  }

  document.addEventListener("DOMContentLoaded", boot);
})();
